module.exports = __webpack_public_path__ + "static/media/30-12.c1ec682f.mp3";